import React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

function Footer() {
  return (
    <>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Our Links</h4>
              <div className="d-flex pt-2">
                {/* <a
                  className="btn btn-square btn-outline-light rounded-circle me-2"
                  href="https://twitter.com/Seasaver"
                  target="_blank"
                >
                  <i className="fab fa-twitter" />
                </a> */}
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-2"
                  href="https://www.facebook.com/profile.php?id61557543413550"
                  target="_blank" rel="noreferrer"
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-2"
                  href="https://www.youtube.com/channel/UCjozCiFYwDR7WqFFL3xLrRw"
                  target="_blank" rel="noreferrer"
                >
                  <i className="fab fa-youtube" />
                </a>
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-2"
                  href="https://www.linkedin.com/company/103121727/"
                  target="_blank" rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in" />
                </a>
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-2"
                  href="https://www.instagram.com/blueplanetecosystem"
                  target="_blank" rel="noreferrer"
                >
                  <i className="fab fa-instagram" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Our Programs</h4>
              {/* <a className="btn btn-link" href="http://planetecosystem.com/individual.html">Individuals</a> */}
              <Link className="btn btn-link" to="/site/individual">
                Individuals
              </Link>
              <Link className="btn btn-link" to="/site/education">
                Educational Institutions
              </Link>
              <Link className="btn btn-link" to="/site/foundation">
                Foundations and Trusts
              </Link>
              <Link className="btn btn-link" to="/site/corporate">
                Corporate Partners
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Quick Links</h4>
              <Link className="btn btn-link" to="/site/about">
                About Us
              </Link>
              <Link className="btn btn-link" to="/site/contact">
                Contact Us
              </Link>
              <Link className="btn btn-link" to="/site/blog">
                Blogs
              </Link>
              {/* <a class='btn btn-link' href='/testimonials'>Testimonial</a> */}
              {/* <a class='btn btn-link' href='/countries'>Countries</a> */}
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
      {/* Copyright Start */}
      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-8 text-center text-md-start mb-3 mb-md-0 col-7">
              ©{" "}
              <a className="border-bottom" href="/">
                2020-2026 Blue Planet Ecosystem
              </a>
              , All Right Reserved.
            </div>
            <div className="col-lg-3 col-md-6 col-5">
              <a href="/">
                <img
                  className="footerimg"
                  src="/img/img/Blue_Planet_v122823_black_background.jpg"
                  alt="logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Copyright End */}
    </>
  );
}

export default Footer;
